/* Set default timezone for moment.js */
moment.tz.setDefault(Settings.timezone);

/* Configure prototype.js to include scrolloffsets in position calculation */
Position.includeScrollOffsets = true;
